/**
 * ハンバーガーメニューの表示を制御するクラス
 */

export default class HamburgerMenu {
  constructor() {
    this.hamburger = document.querySelector('#js-hamburger-menu');
    this.menu = document.querySelector('#js-header-sp');
    this.isOpen = false;
  }

  /**
   * is-activeクラス名をトグルし、アイコンを制御
   */
  toggleMenu() {
    this.isOpen = !this.isOpen;
    this.menu.classList.toggle('is-active');
    this.hamburger.setAttribute('data-open', this.isOpen ? 'true' : 'false');
  }

  /**
   * ハンバーガーメニュークリック時にtoggleMenu関数を実行するイベントを付与
   */
  addEvent() {
    this.hamburger.addEventListener('click', () => this.toggleMenu());
  }

  init() {
    if (!this.hamburger || !this.menu) return;
    this.addEvent();
  }
}
